import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {GetMedicalReport, GetMedicalReportModel, GetMedicalReportParams} from 'domain/usecases';

export class RemoteMedicalReport implements GetMedicalReport {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetMedicalReportModel>,
	) {}

	async get(params: GetMedicalReportParams): Promise<GetMedicalReportModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
